/**
 * System-wide registry identifier for the Products category in the Resource
 * Library. Identical across staging and production, so it is safe to hardcode.
 *
 * Global Search calls it a `resourceSubType`; the medtech data-registry API
 * calls it a `category_id`. Same UUID, two names.
 */
export const PRODUCT_RESOURCE_SUBTYPE = "28dea922-4900-4bec-8541-6818cb985b5e";
